import React from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-207">
      <div className="absolute inset-0 bg-[#0f1c3f]/85 backdrop-blur-[8px]" onClick={onClose} data-id="element-208"></div>
      <div className="relative bg-white border border-brand-blue-primary/15 rounded-[20px] w-full max-w-[680px] max-h-[80vh] flex flex-col shadow-2xl animate-in fade-in zoom-in-95 duration-200" data-id="element-209">
        <div className="flex items-center justify-between p-6 border-b border-brand-blue-primary/10" data-id="element-210">
          <h2 className="font-display font-bold text-xl text-brand-navy-dark" data-id="element-211">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-brand-bg-subtle rounded-full transition-colors text-brand-text-muted hover:text-brand-navy-dark" data-id="element-212">
            <X className="w-5 h-5" data-id="element-213" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto font-body text-[0.82rem] text-brand-text-secondary leading-[1.8] space-y-6" data-id="element-214">
          {children}
        </div>
      </div>
    </div>;
}
export function PrivacyModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Política de Privacidad" data-id="element-215">
      <section data-id="element-216">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-217">
          1. Información que recopilamos
        </h3>
        <p data-id="element-218">
          Recopilamos nombre, correo electrónico, número de teléfono y detalles
          del negocio cuando usted llena nuestros formularios de contacto o
          interactúa con nuestros servicios.
        </p>
      </section>
      <section data-id="element-219">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-220">
          2. Cómo usamos su información
        </h3>
        <p data-id="element-221">
          Utilizamos su información exclusivamente para responder a sus
          consultas, enviar propuestas comerciales y proveer actualizaciones
          sobre nuestros servicios.
        </p>
      </section>
      <section data-id="element-222">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-223">
          3. Compartir información
        </h3>
        <p data-id="element-224">
          Nunca vendemos, alquilamos ni compartimos su información personal con
          terceros para fines de marketing.
        </p>
      </section>
      <section data-id="element-225">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-226">
          4. Seguridad
        </h3>
        <p data-id="element-227">
          Implementamos medidas de seguridad estándar de la industria para
          proteger su información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
      </section>
      <section data-id="element-228">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-229">
          5. Comunicaciones
        </h3>
        <p data-id="element-230">
          Al proporcionar sus datos, acepta recibir comunicaciones según su
          preferencia (Email, SMS, WhatsApp). Puede cancelar su suscripción en
          cualquier momento.
        </p>
      </section>
      <section data-id="element-231">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-232">
          6. Sus derechos
        </h3>
        <p data-id="element-233">
          Usted tiene derecho a solicitar acceso, corrección o eliminación de
          sus datos personales contactándonos a support@iapilotsociety.com.
        </p>
      </section>
      <section data-id="element-234">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-235">
          7. Contacto
        </h3>
        <p data-id="element-236">
          support@iapilotsociety.com · +1 (321) 332-5840 · Orlando, FL. Junio
          2025.
        </p>
      </section>
    </Modal>;
}
export function TermsModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos de Servicio" data-id="element-237">
      <section data-id="element-238">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-239">
          1. Aceptación
        </h3>
        <p data-id="element-240">
          Contratar nuestros servicios implica la aceptación total de estos
          términos y condiciones.
        </p>
      </section>
      <section data-id="element-241">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-242">
          2. Servicios
        </h3>
        <p data-id="element-243">
          Proveemos servicios de diseño web, SEO y presencia digital. Los
          detalles específicos se definirán en la propuesta acordada con cada
          cliente.
        </p>
      </section>
      <section data-id="element-244">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-245">
          3. Pago
        </h3>
        <p data-id="element-246">
          Todos los precios están en USD. Requerimos un pago único sin
          mensualidades (salvo acuerdo contrario). No hay reembolsos una vez
          iniciado el proyecto.
        </p>
      </section>
      <section data-id="element-247">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-248">
          4. Plazos
        </h3>
        <p data-id="element-249">
          Los tiempos de entrega son estimados y pueden variar según la
          complejidad del proyecto y la disponibilidad/respuesta del cliente.
        </p>
      </section>
      <section data-id="element-250">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-251">
          5. Responsabilidades del cliente
        </h3>
        <p data-id="element-252">
          El cliente debe proveer información veraz, materiales gráficos (si
          aplica) y feedback oportuno para no retrasar el proyecto.
        </p>
      </section>
      <section data-id="element-253">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-254">
          6. Propiedad intelectual
        </h3>
        <p data-id="element-255">
          El cliente recibe los derechos de uso del producto final una vez
          pagado en su totalidad. Arvex se reserva el derecho de mostrar el
          trabajo en su portafolio.
        </p>
      </section>
      <section data-id="element-256">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-257">
          7. Limitación de responsabilidad
        </h3>
        <p data-id="element-258">
          Nuestra responsabilidad máxima ante cualquier reclamo no excederá el
          monto total pagado por el cliente por el servicio en cuestión.
        </p>
      </section>
      <section data-id="element-259">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-260">
          8. Soporte
        </h3>
        <p data-id="element-261">
          Incluye consultas y correcciones menores según el plan contratado.
          Cambios de alcance o rediseños tendrán un costo adicional.
        </p>
      </section>
      <section data-id="element-262">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-263">
          9. Ley aplicable
        </h3>
        <p data-id="element-264">
          Estos términos se rigen por las leyes del Estado de Florida, Condado
          de Orange, EE.UU.
        </p>
      </section>
      <section data-id="element-265">
        <h3 className="font-display font-bold text-brand-navy-dark text-base mb-2" data-id="element-266">
          10. Contacto
        </h3>
        <p data-id="element-267">support@iapilotsociety.com · +1 (321) 332-5840. Junio 2025.</p>
      </section>
    </Modal>;
}